import { Box } from "@mui/material";
import { MemberCardHeader } from "./Components/MemberCardHeader";
import { EMPLOYEE_TYPES_ENUM } from "./Enum";
import CustomChip from "../../Components/CustomChip";
import { useSelector } from "react-redux";
import { WhatsAppSection } from "./Components/WhatsAppSection";
import InfoDetail from "../Firms/Components/InfoDetail";

export const MemberCard = ({ member, fetchEmployeeDetails }) => {
  const selectedCompany = useSelector(
    (state) => state.EmployeeReducer?.selectedFirm || null,
  );
  return (
    <Box
      sx={{
        borderRadius: "12px",
        bgcolor: "#fff",
        mb: 1,
        padding: { xs: 1, md: 2 },
        width: "100%",
        minWidth: 0,
      }}>
      <MemberCardHeader
        member={member}
        fetchEmployeeDetails={fetchEmployeeDetails}
      />
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {member.role.value === EMPLOYEE_TYPES_ENUM.OWNER && member.dob && (
          <InfoDetail
            label="Date of Birth"
            value={member?.dob}
            direction="row"
            gap={0.5}
            labelVariant="labelD"
            valueVariant="body1"
            alignItems="flex-start"
          />
        )}
        <InfoDetail
          label="Mobile number"
          value={member?.mobile_number}
          direction="row"
          gap={0.5}
          labelVariant="labelD"
          valueVariant="body1"
          alignItems="flex-start"
        />
        {member.role.value === EMPLOYEE_TYPES_ENUM.OWNER && (
          <WhatsAppSection
            is_whatsapp_same={member.is_whatsapp_same}
            OwnerWhatsappNumber={member.whatsapp_number}
            ownerKey={member.id}
            labelDirection="row"
            firmId={selectedCompany?.firm_id}
            isEditable={member.is_editable}
            onWhatsappVerified={fetchEmployeeDetails}
          />
        )}
      </Box>
      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 1 }}>
        {member.role.value === EMPLOYEE_TYPES_ENUM.STAFF &&
          member.permissions &&
          member.permissions.length > 0 &&
          member.permissions?.map((permission, index) => {
            return (
              <CustomChip
                key={index}
                label={permission.label}
                variant="outlined"
              />
            );
          })}
      </Box>
    </Box>
  );
};
